import { Timestamp } from 'firebase/firestore'
import kevinAvatar from '@/assets/bolierplate/kevin.png'
import alexAvatar from '@/assets/bolierplate/alex.png'
import leslieAvatar from '@/assets/bolierplate/leslie.png'

const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const generateId = () => {
    let id = ''
    for (let i = 0; i < 20; i++) {
        id += CHARS[Math.floor(Math.random() * CHARS.length)]
    }
    return id
}

const KEVIN_ID = 'boilerplate-kevin'
const ALEX_ID = 'boilerplate-alex'
const LESLIE_ID = 'boilerplate-leslie'

export const createDefaults = () => {
    const workspaceId = generateId()
    const projectId = generateId()
    const listId = generateId()
    const statusTodoId = generateId()
    const statusProgressId = generateId()
    const statusDoneId = generateId()
    const now = Timestamp.now()

    const members = [
        {
            id: KEVIN_ID,
            workspaceId,
            userId: KEVIN_ID,
            role: 'owner' as const,
            status: 'active' as const,
            createdAt: null,
            email: 'kevin@example.com',
            fullName: 'Kevin',
            username: 'kevin',
            color: '#FFB199',
            avatarImage: kevinAvatar,
        },
        {
            id: ALEX_ID,
            workspaceId,
            userId: ALEX_ID,
            role: 'member' as const,
            status: 'active' as const,
            createdAt: null,
            email: 'alex@example.com',
            fullName: 'Alex',
            username: 'alex',
            color: '#A0D8F1',
            avatarImage: alexAvatar,
        },
        {
            id: LESLIE_ID,
            workspaceId,
            userId: LESLIE_ID,
            role: 'member' as const,
            status: 'active' as const,
            createdAt: null,
            email: 'leslie@example.com',
            fullName: 'Leslie',
            username: 'leslie',
            color: '#C8B6FF',
            avatarImage: leslieAvatar,
        },
    ]

    const tasks = [
        {
            id: generateId(),
            workspaceId,
            projectId,
            listId,
            number: 1,
            name: 'Define goals for this project',
            description: '',
            ownerId: KEVIN_ID,
            assigneeId: KEVIN_ID,
            statusId: statusTodoId,
            labels: [],
            order: 0,
            isCompleted: false,
            createdAt: now,
            updatedAt: now,
        },
        {
            id: generateId(),
            workspaceId,
            projectId,
            listId,
            number: 2,
            name: 'Create a simple action plan',
            description: '',
            ownerId: KEVIN_ID,
            assigneeId: null,
            statusId: statusProgressId,
            labels: [],
            order: 1,
            isCompleted: false,
            createdAt: now,
            updatedAt: now,
        },
        {
            id: generateId(),
            workspaceId,
            projectId,
            listId,
            number: 3,
            name: 'Assign responsibilities',
            description: '',
            ownerId: KEVIN_ID,
            assigneeId: LESLIE_ID,
            statusId: statusTodoId,
            labels: [],
            order: 2,
            isCompleted: false,
            createdAt: now,
            updatedAt: now,
        },
    ]

    return {
        workspace: {
            id: workspaceId,
            name: 'My Workspace',
            workspaceUrlId: 'workspace',
            workspaceTaskPrefixId: 'WRK',
            avatar: null,
            companySize: null,
            createdBy: '',
            taskCounter: tasks.length,
        },
        statuses: [
            {id: statusTodoId, name: "Todo", color: null, systemType: "todo", order: 0},
            {id: statusProgressId, name: "In Progress", color: "#FFFABB", systemType: null, order: 1},
            {id: statusDoneId, name: "Done", color: null, systemType: "done", order: 2},
        ],
        project: {
            id: projectId,
            workspaceId,
            name: '',
            description: '',
            ownerId: KEVIN_ID,
            members: [ALEX_ID, LESLIE_ID],
            shared_members: [KEVIN_ID, ALEX_ID, LESLIE_ID],
            createdAt: now,
            updatedAt: now,
        },
        members,
        list: {
            id: listId,
            projectId,
            workspaceId,
            name: '',
            order: 0,
            createdAt: now,
        },
        tasks,
    }
}
